module.exports = __webpack_public_path__ + "img/bn_m(4).738c6164.png";